import { render, staticRenderFns } from "./DossierOnboarding.vue?vue&type=template&id=ec8743b0&scoped=true&"
import script from "./DossierOnboarding.vue?vue&type=script&setup=true&lang=js&"
export * from "./DossierOnboarding.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DossierOnboarding.vue?vue&type=style&index=0&id=ec8743b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8743b0",
  null
  
)

export default component.exports